var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "marker-02"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99988 18C9.99988 18 16.2608 12.4348 16.2608 8.26087C16.2608 4.80309 13.4577 2 9.99988 2C6.5421 2 3.73901 4.80309 3.73901 8.26087C3.73901 12.4348 9.99988 18 9.99988 18Z",
    stroke: "#172A47",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 8.00013C12.0001 9.1047 11.1047 10.0001 10.0001 10.0001C8.89557 10.0001 8.00014 9.1047 8.00014 8.00013C8.00014 6.89556 8.89557 6.00013 10.0001 6.00013C11.1047 6.00013 12.0001 6.89556 12.0001 8.00013Z",
    stroke: "#172A47",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.671a004d629e6c626d3fa1610f33f1a4.svg";
export { ForwardRef as ReactComponent };